import { Component, Input } from '@angular/core';
import { Moment } from 'moment';

@Component({
  selector: 'app-question-answer',
  imports: [],
  templateUrl: './question-answer.component.html',
  styleUrl: './question-answer.component.scss',
})
export class QuestionAnswerComponent {
  @Input() answerLabel: string | Moment | Date;
  @Input() questionLabel: string;
}
